












































import {
  defineComponent,
  ref,
  onMounted,
} from '@vue/composition-api';
import { queryUseEntranceInfo } from '@/api/rights/shop-mall';
import type { UseEntranceInfoResponse, EntranceItem } from '@/api/rights/shop-mall/types';
import { MallEntranceTypeEnum } from '@/enums/rights';
import { jumpToNewVersion } from '@/shared/utils/jumpTo';
import { ubtSendError } from '@/shared/utils/ubt';
import { RightArrowOutline12 } from '@hb/coffee-icons';
import { ubtSetupModuleExpose, ubtSetupPageButton } from '@/shared/utils/ubt/ubt-setup';
import { throttle } from 'lodash';
import { NewVersionEnum } from '@/enums/newVersionRoute';
import { myProfleMallModuleName } from './tianqi';

export default defineComponent({
  name: 'ShopMallEntrance',
  components: {
    RightArrowOutline12,
  },
  setup() {
    // 是否展示入口
    const showEntrance = ref(false);
    // 入口列表
    const entranceList = ref<EntranceItem[]>([]);

    const tianqiParams = {
      from: 'finance_shopMall_myProfile_stroll',
    };

    /**
     * 初始化数据
     * 从queryUseEntranceInfo接口获取是否展示该入口
     */
    const initData = async () => {
      try {
        const response: UseEntranceInfoResponse | undefined = await queryUseEntranceInfo();

        // 如果返回数据存在且有入口列表，则展示入口
        if (response?.entranceList && response.entranceList.length > 0) {
          showEntrance.value = true;
          entranceList.value = response?.entranceList;
          ubtSetupModuleExpose(myProfleMallModuleName, {
            ...tianqiParams,
            entranceList: response.entranceList.map((item) => item.entranceType),
          });
        } else {
          // 数据为null或无入口列表，不展示入口
          showEntrance.value = false;
        }
      } catch (error) {
        // 异常情况不展示入口
        showEntrance.value = false;
      }
    };

    /**
     * 根据入口类型获取对应的路由路径
     * @param entranceType 入口类型，使用 MallEntranceTypeEnum 枚举值
     * @returns 路由路径
     */
    const getRoutePathByEntranceType = (entranceType: MallEntranceTypeEnum): string => {
      switch (entranceType) {
        case MallEntranceTypeEnum.HOME:
          // 首页入口，哈啰商城集合页
          return NewVersionEnum.INSTALLMENT_MALL_HOME;
        case MallEntranceTypeEnum.ORDER:
          // 订单入口：跳转到授信订单页
          return NewVersionEnum.INSTALLMENT_MALL_ORDER;
        case MallEntranceTypeEnum.BILL:
          // 账单入口：跳转到分期账单页
          return NewVersionEnum.INSTALLMENT_MALL_BILL;
        case MallEntranceTypeEnum.CREDIT_ORDER:
          // 授信订单入口：跳转到授信订单页
          return NewVersionEnum.INSTALLMENT_MALL_CREDIT_ORDER;
        default:
          return '';
      }
    };

    /**
     * 子项点击 - 根据入口类型跳转到对应页面
     * @param entranceType 入口类型，使用 MallEntranceTypeEnum 枚举值
     */
    const handleItemClick = throttle(async (entranceType: MallEntranceTypeEnum) => {
      try {
        ubtSetupPageButton(myProfleMallModuleName, {
          entranceType,
          ...tianqiParams,
        });

        const routePath = getRoutePathByEntranceType(entranceType);

        // 跳转到信贷新版项目地址
        await jumpToNewVersion(routePath, false, `from=${tianqiParams.from}`);
      } catch (error) {
        ubtSendError('jump to installment mall page error');
      }
    }, 300, { leading: false, trailing: true });

    // 组件挂载时初始化数据
    onMounted(() => {
      initData();
    });

    return {
      showEntrance,
      entranceList,
      handleItemClick,
      MallEntranceTypeEnum,
      RightArrowOutline12,
    };
  },
});
